import React, { useEffect, useState } from "react";
import FormBox from "../../../../components/FormBox/FormBox";
import { OTPInputComponent } from "../../../Login/LoginComp";
import { LoadingButton, SpinnerBlock } from "../../../../Utils/CustomComponent";
import {
  addPaymentAccountSchema,
  updatePaymentAccountSchema,
} from "../../../../Utils/formOptions";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import axios from "../../../../axios";
import urls from "../../../../Utils/urls";
import { commonToast } from "../../../../Utils";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setRefreshBankingDetails } from "../../../../store/reducers/accountSlice";
import { useAbortController } from "../../../../hooks/useAbortController";
import { RoutingNumberValidator } from "../../Pages/ACHPayments/SameDayPayment";
import { ArrowLeft } from "react-bootstrap-icons";
import { handleRoutingDetails } from "../../../../store/reducers/achPaymentSlice";
import { fetchUSStates } from "../../../../store/reducers/dashboardSlice/api";
import { loadingTypes, oracleConfig } from "../../../../Utils/constant";
import PopupWrapper from "../../../../components/PopupWrapper";

const AddBankAccount = () => {
  // const [showOtpInput, setShowOtpInput] = useState(false);
  const [promptFail, setPromptFail] = useState(null);
  const [isRoutingNumberVerified, setIsRoutingNumberVerified] = useState(false);
  const [showRoutingNumberVaildatorPopup, setShowRoutingNumberVaildatorPopup] =
    useState(false);
  const [routingDetails, setRoutingDetails] = useState({});
  // const [otpEntered, setOtpEntered] = useState("");
  // const [isOtpStage, setIsOtpStage] = useState(false);
  // const [afterOtpLoading, setAfterOtpLoading] = useState(false);
  const [disableFWS, setDisableFWS] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [editLoader, setEditLoader] = useState(false);
  // const [otpReceived, setOtpReceived] = useState("");
  const states = useSelector((state) => state.dashboard.USstates.data);
  const status = useSelector((state) => state.dashboard.USstates.status);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signal } = useAbortController();
  const { id } = useParams();
  const location = useLocation();
  const shouldApplyValidation = !location.pathname.includes(
    "/update-bank-account",
  );

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    setError,
    reset,
    clearErrors,
  } = useForm(
    shouldApplyValidation
      ? { ...addPaymentAccountSchema }
      : { ...updatePaymentAccountSchema },
  );

  const userId = localStorage.getItem("apex_userid");
  const routingNumber = watch("ROUTING_NUMBER");

  useEffect(() => {
    if (status === loadingTypes.idle) {
      dispatch(fetchUSStates());
    }
  }, [dispatch, status]);

  useEffect(() => {
    if (id) {
      getBankAccountDetails();
    }

    async function getBankAccountDetails() {
      setEditLoader(true);
      try {
        const res = await axios.get(
          urls.borrower.getBankAccountDetails(id),
          oracleConfig,
        );

        const data = res?.data?.items?.forEach((obj) => {
          Object.entries(obj).forEach(([key, value]) => {
            if (key === "account_number") {
              setValue(key.toUpperCase(), value);
              setValue("verifyAccountNumber", value);
            } else {
              setValue(key.toUpperCase(), value);
            }
          });
        });
      } catch (error) {
        console.error(error);
      } finally {
        setEditLoader(false);
      }
    }
  }, [id]);

  useEffect(() => {
    const handleRoutingNumberValidation = async () => {
      try {
        setDisabled(true);
        const getData = await axios.get(
          urls.borrower.getRoutingNumberValidation(routingNumber),
          { signal },
        );

        if (getData?.data.code == 404) {
          setError("ROUTING_NUMBER", {
            type: "custom",
            message: "Invalid routing number",
          });
          setShowRoutingNumberVaildatorPopup(true);
          setIsRoutingNumberVerified(false);
          setRoutingDetails({});
          dispatch(handleRoutingDetails({}));

          setValue("ACH_BANKNAME", undefined);
          setValue("BANK_ADDRESS", undefined);
          setValue("CITY", undefined);
          setValue("STATE", undefined);
          setValue("ZIPCODE", undefined);
          // setDisableBtn(true);
        } else if (getData?.data.code == 200) {
          setIsRoutingNumberVerified(true);
          setRoutingDetails(getData.data);
          dispatch(handleRoutingDetails(getData.data));
          setValue("ACH_BANKNAME", getData?.data?.bank_name);
          setValue("BANK_ADDRESS", getData?.data?.street_address);
          setValue("CITY", getData?.data?.city);
          setValue("STATE", getData?.data?.state);
          setValue("ZIPCODE", getData?.data?.zip);

          setDisabled(false);
          clearErrors("ROUTING_NUMBER");
        }
        return getData.data;
      } catch (error) {
        setError("ROUTING_NUMBER", {
          type: "custom",
          message: "Routing validation failed",
        });
        setRoutingDetails({});
        dispatch(handleRoutingDetails({}));
        setShowRoutingNumberVaildatorPopup(true);
        setIsRoutingNumberVerified(false);
        // setDisabled(true);

        setValue("ACH_BANKNAME", undefined);
        setValue("BANK_ADDRESS", undefined);
        setValue("CITY", undefined);
        setValue("STATE", undefined);
        setValue("ZIPCODE", undefined);
      }
    };
    if (
      routingNumber?.length === 9 &&
      !location.pathname.includes("/update-bank-account")
    ) {
      handleRoutingNumberValidation();
    } else if (routingNumber?.length && routingNumber?.length !== 9) {
      setError("ROUTING_NUMBER", {
        type: "custom",
        message: "Routing number must be 9 digits",
      });
      setRoutingDetails({});
      dispatch(handleRoutingDetails({}));
      setDisabled(true);
    }
  }, [routingNumber]);

  async function onSubmit(data) {
    const updatedData = {
      USR_EXT_ID: id ? parseInt(id) : null,
      USER_ID: userId,
      ...data,
    };
    setDisableFWS(true);
    try {
      const res = await axios.post(
        urls.borrower.createBankAcccount,
        updatedData,
      );
      if (res.status == "200") {
        toast.success("Successfully added bank account!", {
          ...commonToast,
        });

        dispatch(setRefreshBankingDetails(true));
        setDisableFWS(false);
        navigate("/manage-banking");
      }
    } catch (error) {
      console.error(error);
      setDisableFWS(false);
      toast.error("Some error occurred", {
        ...commonToast,
      });
    }
  }

  if (editLoader) {
    return (
      <div className="row">
        <SpinnerBlock height={"10vh"} />
      </div>
    );
  }

  return (
    <section
      className="rounded"
      style={{ background: "#eeeeee", minHeight: "100vh", padding: "10px" }}
    >
      <article className="container-fluid">
        <div className="p-3 pb-0  mt-1">
          <h6>
            <span
              className="linkClick"
              role="button"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={20} /> Back
            </span>{" "}
            /{" "}
            {location.pathname.includes("/update-bank-account")
              ? "Update"
              : "Add"}{" "}
            Bank Account
          </h6>
        </div>
        <form className="bg-white">
          <div className="p-5">
            <div className="row">
              <div className="mb-4">
                <h4>
                  {location.pathname.includes("/update-bank-account")
                    ? "Update"
                    : "Add"}{" "}
                  Bank Account
                </h4>
              </div>
              <div className="col-sm-12">
                <FormBox
                  options={addAccountArr(states, isRoutingNumberVerified)}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  errors={errors}
                />

                {/* <div className="form-outline mb-1">
                  {showOtpInput && (
                    <>
                      <OTPInputComponent
                        setOtpEntered={setOtpEntered}
                        setOtpReceived={setOtpReceived}
                        onClick={() => handleOtp()}
                        requestFromCHPayment={true}
                      />
                    </>
                  )}
                </div> */}

                <div className=" pt-1 mt-5 mb-5 pb-1">
                  {/* {showOtpInput ? (
                    <LoadingButton
                      className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3 text-white"
                      type="button"
                      onClick={handleSubmit(onSubmit)}
                      title={"Verify OTP and Continue"}
                      disabled={afterOtpLoading}
                      loading={afterOtpLoading}
                    />
                  ) : ( */}
                  <LoadingButton
                    className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3 text-white"
                    type="button"
                    onClick={
                      shouldApplyValidation
                        ? handleSubmit(onSubmit)
                        : () => setShowConfirm(true)
                    }
                    disabled={disableFWS || disabled}
                    loading={disableFWS}
                    // title={"Continue"}
                    title={"Submit"}
                  />
                  {/* )} */}

                  {promptFail && (
                    <div className="alert alert-error" role="alert">
                      {promptFail}
                    </div>
                  )}
                  <br />
                </div>
              </div>
            </div>
          </div>
        </form>
      </article>
      <RoutingNumberValidator
        show={showRoutingNumberVaildatorPopup}
        setShow={setShowRoutingNumberVaildatorPopup}
        clearErrors={clearErrors}
        setDisableBtn={setDisabled}
        routingNumber={routingNumber}
      />

      <ConfirmSubmission
        show={showConfirm}
        setShow={setShowConfirm}
        submitHandler={handleSubmit(onSubmit)}
        loader={disableFWS}
      />
    </section>
  );
};

export default AddBankAccount;

const addAccountArr = (states, isRoutingNumberVerified) => [
  {
    title: "Routing Number *",
    field: "ROUTING_NUMBER",
    type: "number",
    className: "col-6",
  },
  {
    title: "Name as per Bank Account *",
    field: "BENEFICIARY_NAME",
    type: "text",
    className: "col-6",
    // disable: isRoutingNumberVerified,
  },
  // {
  //   title: "Bank Name",
  //   field: "bankName",
  //   type: "text",
  //   className: "col-6",
  // },
  {
    title: "Account Type",
    field: "ACCOUNT_TYPE",
    type: "select",
    className: "col-6",
    options: [
      { label: "Checking", value: "0" },
      { label: "Savings", value: "1" },
    ],
  },
  {
    title: "Bank Name",
    field: "ACH_BANKNAME",
    type: "text",
    className: "col-6",
  },
  {
    title: "Bank Street Address *",
    field: "BANK_ADDRESS",
    type: "textarea",
    className: "col-12",
    // disable: isRoutingNumberVerified,
  },
  {
    title: "City",
    field: "CITY",
    type: "text",
    className: "col-6",
    // disable: isRoutingNumberVerified,
  },
  {
    title: "State",
    field: "STATE",
    type: "select",
    className: "col-6",
    options: states,
    // disable: isRoutingNumberVerified,
  },
  {
    title: "Zipcode *",
    field: "ZIPCODE",
    type: "text",
    className: "col-6",
    // disable: isRoutingNumberVerified,
  },
  {
    title: "Account NickName",
    field: "NICK_NAME",
    type: "text",
    className: "col-6",
  },
  {
    title: "Account Number *",
    field: "ACCOUNT_NUMBER",
    type: "number",
    className: "col-6",
    eyeIcon: true,
  },
  {
    title: "Verify Account Number *",
    field: "verifyAccountNumber",
    type: "number",
    className: "col-6",
    eyeIcon: true,
    disablePaste: true,
  },
];

const ConfirmSubmission = ({ show, setShow, submitHandler, loader }) => {
  function confirmHandler() {
    setShow(false);
    submitHandler();
  }

  return (
    <PopupWrapper
      title={
        <div className="px-5">
          Are you sure you want to update your bank account details?
        </div>
      }
      extraClass="width-800"
      backdrop="static"
      Component={
        <div>
          <p>
            Updating the routing number will change the bank account used for
            future payments. Please confirm that you want to continue.
          </p>
          <div className="d-flex justify-content-end gap-5 mb-3">
            <LoadingButton
              className="btn btn-primary btn-block fa-lg gradient-custom-2 mb-3 text-white"
              type="button"
              onClick={() => confirmHandler()}
              title={"Yes, Update"}
              disabled={loader}
              loading={loader}
            />

            <button
              className="btn btn-secondary"
              onClick={() => setShow(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      }
      toShow={show}
      closeEventHandler={() => setShow(false)}
    />
  );
};
